import { StandardsState } from "./types";

const state: StandardsState = {
  byId: {},
  rootIds: [],
  searchIds: [],
  searchTotalCount: 0,
  loading: false,
};

export default state;
